/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { SupportPlanRequest, SupportPlanResponse } from '../../../types/common/PlanSupport';
import { ModalType } from '../AdminManageSupportPlans.types';

export type ManageSupportModalProps = {
  type: ModalType;
  supportPlan?: SupportPlanResponse;
  onSuccess: () => void;
  onClose: () => void;
};

export const initialValues: SupportPlanRequest = {
  name: '',
  description: '',
  price: 0,
  isDefault: true,
} as const;

export const validationSchema = Yup.object({
  name: Yup.string().required('empty'),
  description: Yup.string().required('empty'),
  price: Yup.number().required('empty'),
  isDefault: Yup.boolean().required(),
});
